// extracted by mini-css-extract-plugin
module.exports = {"backgroundpic":"patientsexpense_backgroundpic__3QMIN","waitinginfo":"patientsexpense_waitinginfo__1s30b","table":"patientsexpense_table__2XedI"};